











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'
import {TipoRelatorioCollection} from '@/model/collection/TipoRelatorioCollection'
import {ListTipoRelatorioSchema} from '@/schema/resource/TipoRelatorio/ListTipoRelatorioSchema'
import {CsvTipoRelatorioSchema} from '@/schema/resource/TipoRelatorio/CsvTipoRelatorioSchema'

@Component
export default class ListTipoRelatorioView extends Mixins(MixinQueryRouter) {
  schema = new ListTipoRelatorioSchema()
  collection = new TipoRelatorioCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: TipoRelatorio) {
    Helper.pushByName('editTipoRelatorio', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new TipoRelatorioCollection().clearFilters().addFilter(params)

    await csv.listCsvTipoRelatorio()
    new CsvTipoRelatorioSchema().downloadCsv(csv.all())
  }
}
